const intialState = {
    dashbordData: [],
};
import { tbwDashboardDataActionTypes } from '../constants/tbw-action-types';
export const tbwDashboardDataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case tbwDashboardDataActionTypes.UPDATE_DASHBOARD_DATA:
            return { ...state, dashbordData: [...payload] };
        default:
            return state;
    }
};
